export default "<app-online-patient-list></app-online-patient-list>\r\n";